export default "__VITE_ASSET__BhGo9rK5__"